import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Cover = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isInvisible',
})`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  ${(props) => props.isInvisible && 'display: none;'};
`;

function Overlay({ isInvisible = false }) {
  return <Cover isInvisible={isInvisible} />;
}

Overlay.propTypes = {
  isInvisible: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default Overlay;
